export default {
      id: "unfulfilled-usage",
      viewBox: "-32 0 512 512",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#unfulfilled",
      toString: function () {
        return this.url;
      }
    }